import React, { memo } from "react";

// @Utility
import { removeStorage } from "../../../../../../../@utility/app/storage";

// Icons (MUI v4)
import ScheduleIcon from "@material-ui/icons/Schedule";
import CancelIcon from "@material-ui/icons/Cancel";
import WarningIcon from "@material-ui/icons/Warning"; // 📍 เพิ่ม Icon สำหรับเคสจับคู่ล้มเหลว
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline"; // 📍 เพิ่ม Icon สำหรับเคส Failed

// CSS
import styles from "./../../../../assets/css/Style.module.css";
import buttonStyles from "./../../../../assets/css/Button.module.css";

const BoxCancel = memo(({ status, cancelTransaction, isExpired }) => {

  // 📍 ฟังก์ชันสำหรับแยกเคสและคืนค่า Title, Description และ Icon
  const getStatusDetail = () => {
    // 1. เคสจับคู่บัญชี P2P ไม่สำเร็จ
    if (["no_match", "match_failed", "unmatched"].includes(status)) {
      return {
        title: "ไม่สามารถจับคู่บัญชีได้",
        text: "ระบบไม่สามารถหาบัญชีที่เหมาะสมได้ในขณะนี้ กรุณาทำรายการใหม่อีกครั้ง",
        Icon: WarningIcon,
      };
    }

    // 2. เคสทำรายการล้มเหลวจากข้อผิดพลาดอื่นๆ
    if (status === "failed") {
      return {
        title: "การทำรายการล้มเหลว",
        text: "เกิดข้อผิดพลาดในการทำรายการ กรุณาลองใหม่อีกครั้ง หรือติดต่อพนักงาน",
        Icon: ErrorOutlineIcon,
      };
    }

    // 3. เคสหมดเวลา
    if (status === "expired" || isExpired) {
      return {
        title: "หมดเวลาการทำรายการ",
        text: "คำสั่งของคุณหมดเวลากรุณายกเลิกรายการ แล้วลองใหม่อีกครั้ง หรือติดต่อพนักงาน",
        Icon: ScheduleIcon,
      };
    }

    // 4. เคสถูกยกเลิก (cancelled, system-cancelled หรือ fallback default)
    return {
      title: "รายการถูกยกเลิก",
      text: "รายการฝากเงินนี้ถูกยกเลิกแล้ว กรุณาทำรายการใหม่อีกครั้ง หรือติดต่อพนักงานหากพบปัญหา",
      Icon: CancelIcon,
    };
  };

  const { title, text, Icon: StatusIcon } = getStatusDetail();

  const handleClearAndClose = () => {
    if (cancelTransaction) {
      removeStorage("paymentResult");
      cancelTransaction();
    }
  };

  return (
    <div className={styles.boxMarginFormTop}>
      <div className={styles.boxDetailTop}>
        <div className="boxDetailQRCodeCancel center bgCard">

          {/* 📍 ดึง Icon มาแสดงแบบ Dynamic */}
          <StatusIcon className="boxDetailQRCodeCancelIcon" />

          <div className={styles.boxMarginTop}>
            <div className="boxDetailQRCodeCancelTextTitle">
              {title}
            </div>
            <div className={styles.boxMarginTop}>
              {text}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.boxMarginFormTop03}>
        <div className="center">
          <button
            className={[buttonStyles.btnConfirm, buttonStyles.btnCancel].join(" ")}
            onClick={handleClearAndClose}
            style={{ width: "100%" }}
          >
            ยกเลิกรายการเติมเงิน
          </button>
        </div>
      </div>
    </div>
  );
});

export default BoxCancel;